let _currentSlug: string | null = null;

export function setCurrentSlug(slug: string | undefined): void {
  _currentSlug = slug ?? null;
}

export function getCurrentSlug(): string | null {
  return _currentSlug;
}
